import { isValidInput } from '@components/common/util/util';
import { REGEX_STRING } from '@components/common/constants';
import { stores } from '@stores/index';
import setupDocs from './source-settings/components/sourceSetupDocs.json';

export const TAB_NAMES = {
  DESTINATIONS: 'Overview',
  SETUP: 'Setup',
  SYNCS: 'Syncs',
  SETTINGS: 'Settings',
  EVENTS: 'Events',
  AUDIT_LOGS: 'Audit Logs',
  RESOURCES: 'Resources',
  CONFIGURATION: 'Configuration',
  TRACKING_PLANS: 'Tracking Plans',
  PERMISSIONS: 'Permissions',
  RETL_CONFIGURATION: 'Configuration',
  ALERTS: 'Alerts',
};

export const validateSourceName = (name: string, flow?: string) => {
  if (!isValidInput(REGEX_STRING.SOURCE_NAME, name.trim())) {
    return `Please enter a valid ${flow || 'source'} name`;
  }

  const isUnique = !stores.sourcesListStore.sources.some(
    (source) => source.name.toLowerCase() === name.toLowerCase(),
  );

  if (!isUnique) {
    return `Please choose a unique ${flow || 'source'} name : ${name}`;
  }

  return '';
};

export const getSourceSetupLink = (sourceDefName: string) =>
  setupDocs.find((d) => d.name.toLowerCase() === sourceDefName.toLowerCase())?.docs;
